module.exports = __webpack_public_path__ + "img/logo_larix@3x.e71b317f.png";